// The register date is date-only, which parses as UTC midnight, so it is
// formatted in UTC too or a viewer behind UTC sees the day before.
export const formatRegisterDate = (dateStr: string | null): string =>
  dateStr
    ? new Date(dateStr).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
      })
    : '-'
